import { createReducer, on } from '@ngrx/store';
import { FinancialStatement } from '../../models/financial-statement.model';
import * as FinancialStatementsActions from './financial-statements.actions';

export interface FinancialStatementsState {
  financialStatements: FinancialStatement[];
  selectedFinancialStatement: FinancialStatement | null;
  loading: boolean;
  error: any;
}

export const initialState: FinancialStatementsState = {
  financialStatements: [],
  selectedFinancialStatement: null,
  loading: false,
  error: null,
};

export const financialStatementsReducer = createReducer(
  initialState,

  // Load Financial Statements
  on(FinancialStatementsActions.loadFinancialStatements, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(
    FinancialStatementsActions.loadFinancialStatementsSuccess,
    (state, { financialStatements }) => ({
      ...state,
      financialStatements,
      loading: false,
    })
  ),
  on(FinancialStatementsActions.loadFinancialStatementsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Load Single Financial Statement
  on(FinancialStatementsActions.loadFinancialStatement, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(FinancialStatementsActions.loadFinancialStatementSuccess, (state, { financialStatement }) => ({
    ...state,
    selectedFinancialStatement: financialStatement,
    loading: false,
  })),
  on(FinancialStatementsActions.loadFinancialStatementFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Create Financial Statement
  on(FinancialStatementsActions.createFinancialStatement, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(FinancialStatementsActions.createFinancialStatementSuccess, (state) => ({
    ...state,
    loading: false,
  })),
  on(FinancialStatementsActions.createFinancialStatementFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Update Financial Statement
  on(FinancialStatementsActions.updateFinancialStatement, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(
    FinancialStatementsActions.updateFinancialStatementSuccess,
    (state, { financialStatement }) => ({
      ...state,
      selectedFinancialStatement: financialStatement,
      loading: false,
    })
  ),
  on(FinancialStatementsActions.updateFinancialStatementFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),

  // Delete Financial Statement
  on(FinancialStatementsActions.deleteFinancialStatement, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(FinancialStatementsActions.deleteFinancialStatementSuccess, (state, { id }) => ({
    ...state,
    financialStatements: state.financialStatements.filter((statement) => statement.id !== id),
    loading: false,
  })),
  on(FinancialStatementsActions.deleteFinancialStatementFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  }))
);
